import "core-js/modules/es.object.get-own-property-descriptor";
import _classCallCheck from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class;

import { lock } from '@/util/decorator';
import { request } from './util'; // 魔方链接

var baseUrl = '//activity.video.qq.com/fcgi-bin/asyn_activity';

var _ref = window.setting.魔方配置 || {},
    抽奖活动ID = _ref.抽奖活动ID,
    抽奖模块ID = _ref.抽奖模块ID; // 配置信息


var config = {
  actId: 抽奖活动ID,
  lottery: 抽奖模块ID
};
var MagicService = (_class = /*#__PURE__*/function () {
  function MagicService() {
    _classCallCheck(this, MagicService);
  }

  _createClass(MagicService, null, [{
    key: "getLotteryInfo",
    value: function getLotteryInfo() {
      var options = {
        type: 21,
        option: 101,
        act_id: config.actId,
        module_id: config.lottery
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "lottery",
    value: function lottery() {
      var options = {
        type: 21,
        option: 100,
        act_id: config.actId,
        module_id: config.lottery
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "bookAct",
    value: function bookAct(reserve) {
      var options = {
        type: 30,
        option: 104,
        act_id: config.actId,
        module_id: reserve
      };
      return request()(baseUrl, options);
    }
  }]);

  return MagicService;
}(), (_applyDecoratedDescriptor(_class, "getLotteryInfo", [lock], Object.getOwnPropertyDescriptor(_class, "getLotteryInfo"), _class), _applyDecoratedDescriptor(_class, "lottery", [lock], Object.getOwnPropertyDescriptor(_class, "lottery"), _class), _applyDecoratedDescriptor(_class, "bookAct", [lock], Object.getOwnPropertyDescriptor(_class, "bookAct"), _class)), _class);
export default MagicService;